import React from 'react';

import FieldValue from 'components/forms/FieldValue';
import { checkIsInternalAdmin } from 'utils/AccessControl/check-is-internal-admin';

export function InternalAdminRoleFieldValue({ children }) {
  return (
    <FieldValue name="adminRole">
      {(value) => {
        const userIsInternalAdmin: boolean = checkIsInternalAdmin({ adminRole: value });
        return children(userIsInternalAdmin);
      }}
    </FieldValue>
  );
}